import { Chargebacks } from './ChargebacksDialog'

export default Chargebacks;